import axiosInstance from "@/services/https/global";
import axios from "axios";
import CONFIG from "@/config";
const baseUrl = `${CONFIG.BASE_URL}/wayapay-settlement-service/api/v1`;

export const updateReferee = async (payload) => {
  try {
    const response = await axiosInstance.patch(
      `${baseUrl}/referrals/assign`,
      payload,
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const createReferee = async (payload) => {
  try {
    const response = await axiosInstance.post(`${baseUrl}/referrals`, payload);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const getReferees = async ({ referralId, params = {} }) => {
  const queryParams = {};
  if (params.search && params.search.trim()) {
    queryParams.search = params.search.trim();
  }
  if (params.page !== undefined) {
    queryParams.page = params.page;
  }
  if (params.size !== undefined) {
    queryParams.size = params.size;
  }

  try {
    const response = await axiosInstance.get(
      `${baseUrl}/referrals/user/${referralId}`,
      {
        params: queryParams,
      },
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }

    throw new Error("An unexpected error occurred");
  }
};
